






















import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings } from "@/shared/core/services/configService";
import store from "@/shared/core/store";
import ProgramPage from "@/shared/components/programs/ProgramPage.vue";
import ProgramPanel from "@/shared/components/programs/ProgramPanel.vue";

@Component({ components: { ProgramPage, ProgramPanel } })
export default class CoursesPage extends Vue {
  loading: boolean = true;
  courses: any[] = [];
  uploadsUrl: string = "";

  get customerId(): number {
    try {
      const raw = localStorage.getItem(window.location.host + "_cc");
      if (raw) {
        const parsed = JSON.parse(raw);
        const val = parsed.value || parsed;
        if (typeof val === "string") return JSON.parse(val).id;
        return val.id;
      }
    } catch (e) {}
    return 0;
  }

  get emptyText(): string {
    if (this.loading) return this.$t("Loading").toString() + "...";
    return this.courses.length === 0 ? this.$t("No courses available").toString() : "";
  }

  async mounted() {
    this.uploadsUrl = store.state.settings?.Uploads || "";
    await this.loadCourses();
  }

  async loadCourses() {
    this.loading = true;
    const crud = new CrudService();
    const [allRes, myRes] = await Promise.all([
      crud.httpGet(`${Settings.HostName}/api/public-courses/list`),
      this.customerId
        ? crud.httpGet(`${Settings.HostName}/api/public-courses/my-courses`)
        : Promise.resolve(null)
    ]);
    const all = allRes?.data || [];
    const my = myRes?.data || [];
    const myMap: any = {};
    my.forEach((c: any) => { myMap[c.id] = c; });
    this.courses = all.map((c: any) => myMap[c.id] ? { ...c, ...myMap[c.id] } : c);
    this.loading = false;
  }

  facts(c: any): string {
    const bits: string[] = [];
    if (c.sectionCount > 1) bits.push(c.sectionCount + " " + this.$t("sections").toString());
    bits.push(c.lessonCount + " " + this.$t("lessons").toString());
    if (c.totalDuration) bits.push(this.formatDuration(c.totalDuration));
    if (c.percentComplete > 0) bits.push(c.completedLessons + " " + this.$t("of").toString() + " " + c.lessonCount + " " + this.$t("completed").toString());
    return bits.join(" · ");
  }

  posterUrl(c: any): string {
    if (!c.poster) return "";
    return c.poster.startsWith("http") ? c.poster : this.uploadsUrl + "/" + c.poster;
  }

  formatDuration(s: number): string {
    if (!s) return "0 min";
    return Math.round(s / 60) + " min";
  }
}
